import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getGoogleImagePull,
  updateGoogleImagePull as updateGoogleImagePullApi
} from '../../services/api/settings.api';

export const fetchGoogleImagePull = createAsyncThunk(
  'settings/fetchGoogleImagePull',
  async () => {
    const res = await getGoogleImagePull();

    if (res && res.status === 200 && res.data) {
      return {
        isGoogleImagePull: res.data.google_image_pull
      };
    }

    return null;
  }
);

export const updateGoogleImagePull = createAsyncThunk(
  'settings/updateGoogleImagePull',
  async (googleImagePull) => {
    const res = await updateGoogleImagePullApi(googleImagePull);
    if (res && res.status === 200 && res.data) {
      return {
        isGoogleImagePull: googleImagePull
      };
    }
    return null;
  }
);
